/* Copyright 2023 (Unpublished) Verto Inc. */

import { Component, OnInit } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

// Can be linked to to automatically trigger code flow without user input
@Component({
  template: '',
})
export class OAuthLoginComponent implements OnInit {
  constructor(private _oAuthService: OAuthService) {}

  ngOnInit() {
    this._oAuthService.loadDiscoveryDocument().then(() => {
      this._oAuthService.initCodeFlow();
    });
  }
}
